// Unpublished Work © 2022-2024 Deere & Company.

import React from 'react';
import PropTypes from 'Utils/prop-type-utils';
import ValidationInput from 'Ui/components/common/form/validation-input';

function EditableQuickTodoSettings(props) {
    const {
        title,
        onChange,
        onSave,
        setValid,
        translations
    } = props;

    return (
        <form
            className='settings-body editable-quick-todo-settings'
            onSubmit={onSave}
        >
            <ValidationInput
                autoFocus={true}
                fullWidth
                label={translations.TITLE}
                name='title'
                onChange={onChange}
                required={true}
                setValid={setValid}
                tabIndex={0}
                type='text'
                value={title}
            />
        </form>
    );
}

EditableQuickTodoSettings.propTypes = {
    onChange: PropTypes.func,
    onSave: PropTypes.func,
    setValid: PropTypes.func,
    title: PropTypes.string,
    translations: PropTypes.translations
};

export default EditableQuickTodoSettings;
